import { call, put, select, takeLatest } from 'redux-saga/effects';
import { callWithAuth } from '../sagaApiHelper';
import { uploadFileRequest, setFileError } from '../filesSlice';
import { uploadFileApi } from '../../api/apiLists/fileUploadApi';
import { uploadFile } from '../../api/apiLists/uploadFile';

export function* handleFileUpload({path, customerId}) {
    try {
        const files = yield select((state) => state.files[path]?.files);

        const inputData = {
            filesData: files.map(file => ({
                fileName: file.name,
                contentType: file.type,
                customerId: customerId
            }))
        };
        const res = yield call(callWithAuth, uploadFileApi, inputData);

        if(res.status && res.data){
            const uploadResponses = res.data;

            let uploadedFiles = [];
            for (let i = 0; i < uploadResponses.length; i++) {
                const fileObj = files[i];
                const uploadObj = uploadResponses[i];

                try {
                    yield call(uploadFile, uploadObj.uploadURL, fileObj.file, {});
                    const fileObject = {
                        name: fileObj.name,
                        fileURL: uploadObj.Key,
                    }
                    uploadedFiles.push(fileObject);

                } catch (error) {
                    console.error('Error uploading file:', fileObj.name, error.message);
                }
            }

            return uploadedFiles;
        }
    } catch (error) {
        yield put(setFileError({
            key: path,
            error: error.message
        }));
    }
}

// Upload a single file/buffer directly (useful for programmatic uploads like CSV content)
export function* uploadBuffer({ fileName, contentType = 'application/octet-stream', data, customerId, operation }) {
    try {
        const fileEntry = { fileName, contentType, customerId };
        if (operation) {
            fileEntry.operation = operation;
        }
        const inputData = {
            filesData: [fileEntry]
        };
        const res = yield call(callWithAuth, uploadFileApi, inputData);
        if (!res || !res.status || !res.data || !Array.isArray(res.data) || res.data.length === 0) {
            throw new Error('Failed to get upload URL');
        }
        const uploadObj = res.data[0];

        // Create a blob from provided data
        let blob;
        if (data instanceof Blob) {
            blob = data;
        } else if (typeof data === 'string' || data instanceof String) {
            blob = new Blob([data], { type: contentType });
        } else if (data instanceof ArrayBuffer || ArrayBuffer.isView(data)) {
            blob = new Blob([data], { type: contentType });
        } else {
            // fallback: stringify
            blob = new Blob([String(data)], { type: contentType });
        }

        yield call(uploadFile, uploadObj.uploadURL, blob, {});

        return {
            name: fileName,
            fileURL: uploadObj.Key,
            uploadURL: uploadObj.uploadURL,
        };
    } catch (error) {
        yield put(setFileError({ key: `uploadBuffer:${fileName}`, error: error.message }));
        throw error;
    }
}

export default function* categoriesSaga() {
    yield takeLatest(uploadFileRequest.type, handleFileUpload);
}
